import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { FaqService } from '../../services/faq.service';
import { IFaqDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-consultant-pharmacist',
  templateUrl: './consultant-pharmacist.component.html',
  styleUrls: ['./consultant-pharmacist.component.css']
})
export class ConsultantPharmacistComponent implements OnInit {

  faq: IFaqDto;
  loading = false;

  constructor(private sharedService: SharedService, private faqService: FaqService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadFaq();
  }

  loadFaq() {
    this.loading = true;
    this.faqService.getFaqByCode('consultant-pharmacist').subscribe(result => {
      this.faq = result;
      this.sharedService.showLoadingMessage = false;
      this.loading = false;
    }, error => {
      console.error(error);
      this.sharedService.showLoadingMessage = false;
      this.loading = false;
    });
  }

}
